import React from "react"
import { SubscriptionProvider } from "./src/context/SubscriptionContext"
import { SettingsProvider } from "./src/context/SettingsContext"
import Layout from './src/components/Layout'
// const Layout = require('./src/components/Layout').default

// Console Logs unterdrücken (nicht anzeigen)
if (process.env.NODE_ENV !== "development") {
  console.log = function () {}; // Leere Funktion, unterdrückt Logs
}

export const wrapPageElement = ({ element, props }) => {
  return (
    <Layout {...props}>
      <SubscriptionProvider>
        <SettingsProvider>
          {element}
        </SettingsProvider>
      </SubscriptionProvider>
    </Layout>
  )
}

// Service Worker für Firebase registrieren
// export const onClientEntry = () => {
//   if (typeof window !== "undefined" && "serviceWorker" in navigator) {
//     navigator.serviceWorker
//       .register('/firebase-messaging-sw.js')
//       .then((registration) => {
//         console.log('Service Worker erfolgreich registriert:', registration);
//       })
//       .catch((error) => {
//         console.error('Fehler bei der Registrierung des Service Workers:', error);
//       });
//   }
// };

// export const onClientEntry = () => {
//   if ("serviceWorker" in navigator) {
//     navigator.serviceWorker
//       .register("/firebase-messaging-sw.js", { scope: "/app/" }) // Setze den Scope explizit
//       .then((registration) => {
//         console.log("Service Worker für Firebase Messaging registriert:", registration);
//       })
//       .catch((error) => {
//         console.error("Service Worker Registrierung fehlgeschlagen:", error);
//       });
//   }
// };



// export const wrapRootElement = ({ element }) => {
//     <SubscriptionProvider>{element}</SubscriptionProvider>
// }

// export const wrapPageElement = ({ element }) => {
//     <SettingsProvider>{element}</SettingsProvider>
// }




